var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable */
// @ts-nocheck
import { buildPointLightGrid, AnimationDirection, } from "@rendering/vortex-core";
import { AnimationMixer } from "three";
import { centerModel, findMeshRecursively, getSurfaceMapping } from "../common";
import { buildDracoLoader, buildGLTFLoader } from "./utils";
import { ModelAnimation } from "../modelProduct";
export class GltfProduct {
    constructor(config) {
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "custom model"
        });
        Object.defineProperty(this, "modelUri", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "meshGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rotationOffset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "positionOffset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "surfaceMapping", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // @ts-ignore
        Object.defineProperty(this, "dracoLoader", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "animationClips", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mixer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productStates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "surfaceAliases", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.animationClips = [];
        this.modelUri = config.modelUri;
        this.rotationOffset = config.rotationOffset;
        this.positionOffset = config.positionOffset;
        this.dracoLoader = buildDracoLoader();
        if (config.modelStates && config.modelStates.length > 0) {
            this.productStates = config.modelStates;
        }
        else {
            this.productStates = [];
        }
        // eslint-disable-next-line prefer-destructuring
        this.currentState = this.productStates[0];
        // set alias mapping for surfaces if there is any
        const aliases = {};
        // eslint-disable-next-line no-return-assign
        // @ts-ignore
        Object.entries(config.productMapping).map(([id, data]) => (aliases[id] = data.alias));
        this.surfaceAliases = aliases;
        // replace surfaceMapping ids with alias if exist
        const surfaceMap = {};
        Object.entries(getSurfaceMapping(config.productMapping, config.fullBleed)).forEach(([key, data]) => {
            var _a;
            // @ts-ignore
            const id = (_a = aliases[key]) !== null && _a !== void 0 ? _a : key;
            surfaceMap[id] = data;
        });
        this.surfaceMapping = surfaceMap;
    }
    getGeometry() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.meshGroup) {
                return this.meshGroup;
            }
            yield this.preLoad();
            if (this.meshGroup === undefined) {
                throw new Error("Failed to load model from uri");
            }
            return this.meshGroup;
        });
    }
    getSurfaceMapping() {
        return this.surfaceMapping;
    }
    setProductSurface(surfaceId, productSurface) {
        if (this.surfaceMapping[surfaceId]) {
            this.surfaceMapping[surfaceId] = Object.assign(Object.assign({}, this.surfaceMapping[surfaceId]), productSurface);
        }
        else {
            throw new Error(`'${surfaceId}' is not a surface on this modeled product`);
        }
    }
    getAreaLights(pointLightIntensity, directionalLightIntensity) {
        const pointLightIntensities = [
            0.42 * pointLightIntensity,
            0.42 * pointLightIntensity,
            0.3885 * pointLightIntensity,
            0.3885 * pointLightIntensity,
            0.4515 * pointLightIntensity,
            0.42 * pointLightIntensity,
        ];
        return buildPointLightGrid(pointLightIntensities);
    }
    getCurrentState() {
        return this.currentState;
    }
    setStates(productState) {
        this.productStates = productState;
    }
    setCurrentState(stateId) {
        const newState = this.getStates().find((state) => state.id === stateId);
        if (newState) {
            this.currentState = newState;
        }
        else {
            throw new Error(`'${stateId} is not a state defined in this product!`);
        }
    }
    getStates() {
        return this.productStates;
    }
    getAnimationIds() {
        const animationIds = [];
        this.animationClips.forEach((clip) => animationIds.push(clip.name));
        return animationIds;
    }
    buildAnimation(animationOptions) {
        // create mixer for this product if mixer has not been created
        if (this.mixer === undefined) {
            this.mixer = new AnimationMixer(this.meshGroup);
        }
        const clip = this.getAnimationClip(animationOptions.animationId);
        const options = {
            direction: animationOptions.direction,
            duration: animationOptions.duration,
        };
        return new ModelAnimation(this.mixer, clip, options);
    }
    getAnimationClip(animationId) {
        let clip;
        if (animationId) {
            const result = this.animationClips.find((entry) => entry.name === animationId);
            if (result) {
                clip = result;
            }
            else {
                throw new Error(`Animation with name ${animationId} was not found`);
            }
        }
        else if (this.animationClips.length > 0) {
            // eslint-disable-next-line prefer-destructuring
            clip = this.animationClips[0];
        }
        else {
            throw new Error("No animation was found");
        }
        return clip;
    }
    preLoad() {
        if (this.meshGroup !== undefined) {
            return Promise.resolve();
        }
        // @ts-ignore
        const gltfLoader = buildGLTFLoader(this.dracoLoader);
        return new Promise((resolve) => {
            // @ts-ignore
            gltfLoader.load(this.modelUri, (gltf) => {
                // Apply rotation offsets before the model is re-sized
                if (this.rotationOffset) {
                    gltf.scene.rotation.set(this.rotationOffset.yaw, this.rotationOffset.pitch, this.rotationOffset.roll);
                }
                if (gltf.animations) {
                    // @ts-ignore
                    gltf.animations.forEach((clip) => {
                        this.animationClips.push(clip);
                    });
                }
                if (this.productStates.length === 0) {
                    this.productStates.push({ id: "Folded" });
                    this.animationClips.forEach((clip) => {
                        this.productStates.push({
                            id: `${clip.name}-forward`,
                            dependency: {
                                stateId: "Folded",
                                animationId: clip.name,
                                animationDirection: AnimationDirection.forward,
                            },
                        });
                    });
                    // eslint-disable-next-line prefer-destructuring
                    this.currentState = this.productStates[0];
                }
                this.meshGroup = centerModel(this.positionOffset, gltf.scene);
                findMeshRecursively(this.meshGroup, (mesh) => {
                    var _a, _b;
                    const id = (_a = this.surfaceAliases[mesh.uuid]) !== null && _a !== void 0 ? _a : mesh.uuid;
                    // replace mesh uuid with alias if one exists
                    mesh.uuid = id;
                    // Clone and position a mesh to use for each finish
                    if (this.surfaceMapping[id].finishes) {
                        // @ts-ignore
                        for (const finish of this.surfaceMapping[id].finishes) {
                            const clone = mesh.clone();
                            // Update the name for the finish
                            clone.uuid = `${id}-${finish.name}`;
                            clone.name = `${id}-${finish.name}`;
                            // Link the mesh to it's parent
                            clone.parent = mesh.parent;
                            (_b = mesh.parent) === null || _b === void 0 ? void 0 : _b.children.push(clone);
                        }
                    }
                });
                resolve();
            });
        });
    }
    dispose() {
        this.meshGroup = undefined;
        this.dracoLoader.dispose();
    }
}
//# sourceMappingURL=gltfProduct.js.map